import s from '#components/common/richText/richText.module.scss';

type Props = {
  text: string;
};

const RichText = ({ text }: Props) => {
  return <div className={s.host} dangerouslySetInnerHTML={{ __html: text }} />;
};

export default RichText;
